
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M100 0c55.23 0 100 44.77 100 100s-44.77 100-100 100S0 155.23 0 100 44.77 0 100 0z"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#FFBE1B","stroke-width":"4.766","d":"M145.04 158.61a3.83 3.83 0 01-3.83 3.83s0 0 0 0H61.02a3.83 3.83 0 01-3.83-3.83s0 0 0 0V50.12a3.83 3.83 0 013.83-3.83h61.03l22.98 22.98.01 89.34z"}}),_c('path',{attrs:{"fill":"#FFBE1B","stroke":"#FFBE1B","stroke-width":"4.766","d":"M145.04 69.28h-19.3c-2.03 0-3.67-1.64-3.67-3.67 0 0 0 0 0 0v-19.3"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFBE1B","stroke-width":"4.766","d":"M74.43 96.67h56.48M74.43 119.66h56.48M74.43 142.64h39"}}),_c('path',{attrs:{"opacity":".19","fill":"#FFBE1B","stroke":"#FFBE1B","stroke-width":"4.766","d":"M145.04 158.61a3.83 3.83 0 01-3.83 3.83s0 0 0 0H61.02a3.83 3.83 0 01-3.83-3.83s0 0 0 0V50.12a3.83 3.83 0 013.83-3.83h61.03l22.98 22.98.01 89.34z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M166.184 91.802l-36.633 48.613-16.292-12.277 36.633-48.613z"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFBE1B","stroke-width":"4.766","d":"M162.837 92.272l-33.762 44.804-12.483-9.406 33.762-44.804z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M115.662 132.928l8.618 6.494-8.578 2.426-.04-8.92z"}}),_c('path',{attrs:{"fill":"#FFBE1B","d":"M113.331 144.995l-.07-16.856 16.293 12.277-16.223 4.579z"}}),_c('path',{attrs:{"fill":"none","stroke":"#FFBE1B","stroke-width":"4.766","d":"M145.31 87.837l14.143 10.659"}})])
          )
        }
      }
    